import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'
import { API_BASE_URL } from './config/api'

axios.defaults.baseURL = API_BASE_URL

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
